module.exports = __webpack_public_path__ + "img/icon_googlemaps.a9ea2234.png";